import React from "react";
import {
  createBrowserRouter,
  Navigate,
  Route,
  createRoutesFromElements,
  Outlet,
} from "react-router-dom";
import { observer } from "mobx-react";
import { useStore } from "../hooks";
import AppPage from "../components/app/index";
import ErrorPage from "../error-page";
import CustomerAccountPage from "../pages/CustomerAccountPage";
import KeyPage from "../pages/CustomerDataPlatformPage";
// [DEPRECATED_GRAPHQL] - Para eliminación: ContactPage usa dataStore.getData que usa GraphQL query getData
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import ContactPage from "../pages/ContactPage";
import DashboardsPage from "../pages/DashboardsPage/DashboardsPage";
import UsersPage from "../pages/v2/UsersPage";
import ForbiddenPage from "../components/forbidenPage"; // Updated import
import UnifiedProfileManagement from "../pages/v2/UnifiedProfilePage/index";
import AnnUnifiedProfilePage from "../pages/AnnUnifiedProfile";
//v2
// [DEPRECATED_GRAPHQL] - Para eliminación: AsistantManagement usa GraphQL queries
// TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
// import AssistantManagementPageV2 from "../pages/v2/AsistantManagement";
import AgentsTeamPage from "../pages/v2/AgentsTeam";
import TemplateEditor from "../elements/v2/TemplateEditor/TemplateEditor";
import ConversationPage from "../pages/v2/Conversations";
import RolesPage from "../pages/v2/RolesPage";
import HomePageV2 from "../pages/v2/HomePage";
import HomePageV2New from "../pages/v2/HomePageV2";
import GroupsPage from "../pages/v2/GroupsPage";
import PersonalizationPage from "../pages/v2/PersonaPage/PersonaPage";

import { Loading } from "../components/loading";
import HumanInTheLoop from "../elements/v2/HumanInTheLoop/HumanInTheLoop";
// [DEPRECATED_GRAPHQL] - Para eliminación: NotificationUserPage usa AlertTab que usa GraphQL
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import NotificationUserPage from "../pages/v2/NotificationUserPage";
// [DEPRECATED_GRAPHQL] - Para eliminación: Estas páginas usan dataStore.getData que usa GraphQL query getData
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import VehiclePage from "../pages/v2/VehiclesPage/VehiclesPage";
// import RepairOrdersPage from "../pages/v2/RepairOrdersPage/RepairOrderPage";
// import AppointmentsPage from "../pages/v2/AppointmentsPage/AppointmentsPage";
import ProfilePageV2 from "../pages/v2/ProfilePage/ProfilePage";
// import InventoryPage from "../pages/v2/InventoryPage/InventoryPage";
import ChatWidgetComponent from "../pages/v2/EmbeddedChatPage/ChatWidgetComponent";
import QuestionnairesPage from "../pages/v2/QuestionsPage";
// [DEPRECATED_GRAPHQL] - Para eliminación: AlertPage usa GraphQL queries
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import AlertPage from "../pages/v2/AlertPage";
import { Authenticator } from "@aws-amplify/ui-react";
import { Signin } from "../components";
import VaultPage from "../pages/v2/VaultPage/VaultPage";
import PromptManagementSystemPage from "../pages/v2/PromptManagementSystemPage/PromptManagementSystemPage";
import PerformancePage from "../pages/v2/Performance/PerformancePage";
import SupressionRule from "../pages/v2/SupressionRulesPage/SupressionRule";
import { PermissionCodes } from "../utils/enums";
import PMSystemPage from "../pages/v2/PMSystemPage/PMSystemPage";
import TriggersPage from "../pages/v2/TriggersPage";
import UCPPageV2 from "../pages/v2/UCPPage";
import PlaygroundPage from "../pages/v2/Playground";
import PlaygroundPageV2 from "../pages/v2/PlaygroundV2";
import AgentsViewPage from "../pages/v2/AgentsView";
import AgentsViewPageV2 from "../pages/v2/AgentsViewV2";
import DrivesPage from "../pages/v2/DrivesPage";
import UserManagementPage from "../pages/v2/UserManagement";
import WorkspacePage from "../pages/v2/Workspace";
import DepartmentsPage from "../pages/v2/Departments";
import KnowledgePage from "../pages/v2/Knowledge";
import BlastCampaignPage from "../pages/v2/BlastCampaignPage";

const ProtectedRoute = observer(
  ({ element: Element, permissionCode, ...rest }) => {
    const { authStore } = useStore();

    return (
      <>
        {authStore.isLoading && <Loading />}
        {!authStore.isLoading && (
          <>
            {authStore.isGroupSuperAdmin ||
              authStore.isGroupAdmin ||
              (authStore.userPermissions.length &&
                authStore.hasPermission(permissionCode, "VIEW")) ? (
              <Element {...rest} />
            ) : (
              <ForbiddenPage />
            )}
          </>
        )}
      </>
    );
  }
);

const AppLayout = () => (
  <Authenticator.Provider>
    <Signin>
      <AppPage>
        <Outlet />
      </AppPage>
    </Signin>
  </Authenticator.Provider>
);

const RoutesMenu = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/chat/*"
        element={<ChatWidgetComponent />}
        errorElement={<ErrorPage />}
      />
      <Route path={"/*"} element={<AppLayout />} errorElement={<ErrorPage />}>
        <Route
          path="forbidden"
          element={<ForbiddenPage />}
          errorElement={<ErrorPage />}
        />

        <Route
          index
          element={<Navigate to="/home" />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="home"
          element={
            <ProtectedRoute element={HomePageV2} permissionCode="HOME" />
          }
          errorElement={<ErrorPage />}
        />
        <Route
          path="customers/*"
          element={
            <ProtectedRoute
              element={CustomerAccountPage}
              permissionCode="CUSTOMERS_VIEW"
            />
          }
          errorElement={<ErrorPage />}
        />
        <Route
          path="keys/*"
          element={
            <ProtectedRoute element={KeyPage} permissionCode="KEYS_VIEW" />
          }
          errorElement={<ErrorPage />}
        />
        {/* [DEPRECATED_GRAPHQL] - Para eliminación: ContactPage usa dataStore.getData que usa GraphQL query getData */}
        {/* TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente */}
        {/* Fecha de deprecación: 2024-12-19 */}
        {/* <Route
          path="contacts/*"
          element={
            <ProtectedRoute
              element={ContactPage}
              permissionCode={PermissionCodes.DATA_CONTACTS}
            />
          }
          errorElement={<ErrorPage />}
        /> */}
        <Route
          path="metrics/*"
          element={
            <ProtectedRoute
              element={DashboardsPage}
              permissionCode="METRICS_VIEW"
            />
          }
          errorElement={<ErrorPage />}
        />
        <Route
          path="unified-profile"
          element={
            <ProtectedRoute
              element={UnifiedProfileManagement}
              permissionCode={PermissionCodes.UCP_ACCESS}
            />
          }
          errorElement={<ErrorPage />}
        />
        <Route
          path="ann-unified-profile"
          element={
            <ProtectedRoute
              element={AnnUnifiedProfilePage}
              permissionCode={PermissionCodes.UCP_ACCESS}
            />
          }
          errorElement={<ErrorPage />}
        />

        <Route path="v2">
          <Route
            path="home"
            element={
              <ProtectedRoute element={HomePageV2New} permissionCode="HOME" />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="agents-team/*"
            element={
              <ProtectedRoute
                element={AgentsTeamPage}
                permissionCode="AGENTS_TEAM_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          {/* [DEPRECATED_GRAPHQL] - Para eliminación: AsistantManagement usa GraphQL queries
          TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente */}
          {/* <Route
            path="assistants/*"
            element={
              <ProtectedRoute
                element={AssistantManagementPageV2}
                permissionCode="AGENTS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          /> */}
          <Route
            path="template/*"
            element={
              <ProtectedRoute
                element={TemplateEditor}
                permissionCode="TEMPLATE_EDIT"
              />
            }
          />
          <Route
            path="users/*"
            element={
              <ProtectedRoute element={UsersPage} permissionCode="USERS_VIEW" />
            }
            errorElement={<ErrorPage />}
          />

          <Route
            path="questions/*"
            element={
              <ProtectedRoute
                element={QuestionnairesPage}
                permissionCode="QUESTIONS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />

          <Route
            path="conversations/*"
            element={
              <ProtectedRoute
                element={ConversationPage}
                permissionCode="CONVERSATIONS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          {/* [DEPRECATED_GRAPHQL] - Para eliminación: AlertPage usa GraphQL queries */}
          {/* TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente */}
          {/* Fecha de deprecación: 2024-12-19 */}
          {/* <Route
            path="alerts/*"
            element={<ProtectedRoute element={AlertPage} />}
            errorElement={<ErrorPage />}
          /> */}
          <Route
            path="roles/*"
            element={
              <ProtectedRoute element={RolesPage} permissionCode="ROLES_VIEW" />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="groups/*"
            element={
              <ProtectedRoute
                element={GroupsPage}
                permissionCode="GROUPS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="personalization/*"
            element={<PersonalizationPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="unified-profile"
            element={
              <ProtectedRoute
                element={UnifiedProfileManagement}
                permissionCode={PermissionCodes.UCP_ACCESS}
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="human/*"
            element={<HumanInTheLoop />}
            errorElement={<ErrorPage />}
          />
          {/* [DEPRECATED_GRAPHQL] - Para eliminación: NotificationUserPage usa AlertTab que usa GraphQL */}
          {/* TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente */}
          {/* Fecha de deprecación: 2024-12-19 */}
          {/* <Route
            path="notifications/*"
            element={<NotificationUserPage />}
            errorElement={<ErrorPage />}
          /> */}
          {/* [DEPRECATED_GRAPHQL] - Para eliminación: Estas páginas usan dataStore.getData que usa GraphQL query getData */}
          {/* TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente */}
          {/* Fecha de deprecación: 2024-12-19 */}
          {/* <Route
            path="vehicles/*"
            element={<VehiclePage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="repair-orders/*"
            element={<RepairOrdersPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="appointments/*"
            element={<AppointmentsPage />}
            errorElement={<ErrorPage />}
          /> */}
          <Route
            path="profile/*"
            element={
              <ProtectedRoute
                element={ProfilePageV2}
                permissionCode="PROFILE_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          {/* <Route
            path="inventory/*"
            element={<InventoryPage />}
            errorElement={<ErrorPage />}
          /> */}
          <Route
            path="prompt-management-system/*"
            element={
              <ProtectedRoute
                element={PromptManagementSystemPage}
                permissionCode="AGENTS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="vault/*"
            element={<VaultPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="suppression-rules/*"
            element={
              <ProtectedRoute
                element={SupressionRule}
                permissionCode="SUPPRESSION_RULES_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="pms/*"
            element={
              <ProtectedRoute
                element={PMSystemPage}
                permissionCode="PMS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="workflows/*"
            element={<TriggersPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="performance/*"
            element={
              <ProtectedRoute
                element={PerformancePage}
                permissionCode="CONVERSATIONS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="ucp/*"
            element={<UCPPageV2 />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="playground/*"
            element={
              <ProtectedRoute
                element={PlaygroundPage}
                permissionCode={PermissionCodes.PLAYGROUND_VIEW}
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="playground2/*"
            element={
              <ProtectedRoute
                element={PlaygroundPageV2}
                permissionCode={PermissionCodes.PLAYGROUND_VIEW}
              />
            }
            errorElement={<ErrorPage />}
          />
          {/* <Route
            path="agentsView/*"
            element={<AgentsViewPage />}
            errorElement={<ErrorPage />}
          /> */}
          <Route
            path="agentsView/*"
            element={<AgentsViewPageV2 />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="drives/*"
            element={<DrivesPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="user-management/*"
            element={
              <ProtectedRoute
                element={UserManagementPage}
                permissionCode="USER_MANAGEMENT_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="workspace/*"
            element={<WorkspacePage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="departments/*"
            element={<DepartmentsPage />}
            errorElement={<ErrorPage />}
          />
          <Route
            path="knowledge/*"
            element={
              <ProtectedRoute
                element={KnowledgePage}
                permissionCode="KNOWLEDGE_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
          <Route
            path="blast-campaigns/*"
            element={
              <ProtectedRoute
                element={BlastCampaignPage}
                permissionCode="BLAST_CAMPAIGNS_VIEW"
              />
            }
            errorElement={<ErrorPage />}
          />
        </Route>

      </Route>
    </>
  )
);

export default RoutesMenu;
